var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EDFEF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1925 21.1352L21.9675 13.9202C22.1329 13.716 22.3654 13.5771 22.6236 13.5282C22.8818 13.4793 23.149 13.5236 23.3776 13.6532C23.6062 13.7828 23.7814 13.9893 23.872 14.2359C23.9626 14.4826 23.9628 14.7534 23.8725 15.0002L22.3725 19.1102H24.375C24.653 19.1183 24.9233 19.2036 25.1557 19.3565C25.388 19.5093 25.5733 19.7238 25.6907 19.9759C25.8082 20.228 25.8533 20.5078 25.821 20.784C25.7886 21.0603 25.6801 21.3221 25.5075 21.5402L19.98 28.1027C19.8067 28.2837 19.5772 28.4007 19.3288 28.4347C19.0805 28.4687 18.828 28.4176 18.6124 28.2898C18.3968 28.162 18.2307 27.965 18.1413 27.7308C18.052 27.4967 18.0444 27.2392 18.12 27.0002L19.4475 23.5502H17.3475C17.0702 23.544 16.8001 23.4611 16.5671 23.3106C16.3341 23.1601 16.1473 22.948 16.0277 22.6977C15.908 22.4475 15.86 22.169 15.8891 21.8931C15.9183 21.6173 16.0233 21.3549 16.1925 21.1352Z",
    fill: "#00A852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.5e1c83e290f9c77b74b06772a32b8469.svg";
export { ForwardRef as ReactComponent };